import { SiteLayoutComponent, SiteSection } from 'shared/components/site-layout';
import { PageWithSettingsComponent, SimpleTitle } from 'shared/components/page-with-settings';

import { SettingsComponent } from './SettingsComponent';
import { MapComponent } from './MapComponent';
import { useSelector } from 'react-redux';
import { ReturnsMapStore } from '../model/redux-model';
import { LoadingComponent } from 'shared/components/loading';

export const PageComponent = () => {
	const isLoaded = useSelector<ReturnsMapStore>(x => x.etfs.isLoaded);

	return (
		<SiteLayoutComponent activeSection={SiteSection.Map}>
			{
				isLoaded
					? <PageWithSettingsComponent
							settingsTitleChild={props => <SimpleTitle {...props} text="Настройка пульса" />}
							settingCompactModeShowButtonText="Настройка пульса"
							defaultIsSettingsExpanded={false}
							settingsContentChild={<SettingsComponent />}
							contentChild={<MapComponent />} />
					: <LoadingComponent />
			}
			
		</SiteLayoutComponent>
	);
}